<div class="user-view">
  <a routerLink="/admin/users" class="back-link">← {{ backText }}</a>

  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="loading" class="loading-message">{{ loadingText }}</div>

  <ng-container *ngIf="!loading && !error && user">
    <!-- Шапка: пользователь и действия (редактирование и удаление — только здесь) -->
    <div class="view-head">
      <div class="view-head__who">
        <span class="avatar">{{ initials }}</span>
        <div>
          <h1>{{ user.fullName }}</h1>
          <span class="role-badge">{{ getRoleName(user.role) }}</span>
        </div>
      </div>

      <div class="view-head__actions">
        <button type="button" class="btn btn--primary" (click)="editUser()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4"/></svg>
          {{ editText }}
        </button>
        <button type="button" class="btn btn--danger" (click)="deleteUser()" [disabled]="deleting">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>
          {{ deleteText }}
        </button>
      </div>
    </div>

    <!-- Подтверждение удаления — на странице, без системного окна браузера -->
    <div class="delete-confirm" *ngIf="confirmDeleteOpen" role="alertdialog" [attr.aria-label]="confirmDeleteText">
      <p>{{ confirmDeleteText }}</p>
      <div class="delete-confirm__actions">
        <button type="button" class="btn btn--ghost" (click)="confirmDeleteOpen = false" [disabled]="deleting">{{ cancelText }}</button>
        <button type="button" class="btn btn--danger-solid" (click)="confirmDelete()" [disabled]="deleting">{{ deleting ? deletingText : deleteText }}</button>
      </div>
      <p class="delete-confirm__error" *ngIf="deleteError" role="alert">{{ deleteError }}</p>
    </div>

    <section class="card">
      <dl class="details">
        <div>
          <dt>{{ emailText }}</dt>
          <dd><a [href]="'mailto:' + user.email">{{ user.email }}</a></dd>
        </div>
        <div>
          <dt>{{ phoneText }}</dt>
          <dd>{{ user.phone || '—' }}</dd>
        </div>
        <div>
          <dt>{{ roleText }}</dt>
          <dd>{{ getRoleName(user.role) }}</dd>
        </div>
        <div>
          <dt>{{ createdAtText }}</dt>
          <dd>{{ formatDate(user.createdAt) }}</dd>
        </div>
        <div>
          <dt>{{ updatedAtText }}</dt>
          <dd>{{ formatDate(user.updatedAt) }}</dd>
        </div>
        <div class="details__wide">
          <dt>{{ commentText }}</dt>
          <dd [class.muted]="!user.comment">{{ user.comment || noCommentText }}</dd>
        </div>
      </dl>
    </section>
  </ng-container>
</div>
